import { isEmptyString } from './text';

export const getTypeErrorMessage = type => isEmptyString(type) 
    ? 'Location type is required.'
    : '';

export const getNameErrorMessage = name => {
    if (isEmptyString(name)) return 'Location name is required.';
    if (name.length > 50) return 'Name exceeds 50 character limit.';
    return '';
};

export const getInstructionErrorMessage = instructions => instructions && instructions.length > 100 
    ? 'Instructions exceeds 100 character limit.'
    : '';
    
export const isLocationValid = (type, name, instructions) => (
    isEmptyString(getTypeErrorMessage(type)) &&
    isEmptyString(getNameErrorMessage(name)) &&
    isEmptyString(getInstructionErrorMessage(instructions))
);
